<script lang="ts" setup>
defineProps<{ visible: boolean }>();

const emit = defineEmits<{
  (event: 'update:visible', value: boolean): void;
}>();

const { t } = useI18n();
</script>

<template>
  <Dialog
    :header="t('title')"
    :visible="visible"
    @update:visible="emit('update:visible', $event)"
    style="width: 540px"
    dismissable-mask
    :base-z-index="5"
    :draggable="false"
    modal
  >
    <div class="leading-6 md:py-2">
      <p class="mt-0">
        {{ t('descriptions.0') }}
      </p>
      <p>{{ t('descriptions.1') }}</p>
      <p>{{ t('actions_title') }}</p>
      <ul class="pl-0 mb-0">
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-check-circle text-xl" style="color: #9fdaa8" />
          <span>{{ t('actions.0') }}</span>
        </li>
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-clock text-xl" style="color: #f19ea6" />
          <span>{{ t('actions.1') }}</span>
        </li>
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-arrow-circle-up text-xl" style="color: #8dd0ff" />
          <span>{{ t('actions.2') }}</span>
        </li>
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-replay text-xl" style="color: #8dd0ff" />
          <span>{{ t('actions.3') }}</span>
        </li>
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-heart text-xl" style="color: #8dd0ff" />
          <span>{{ t('actions.4') }}</span>
        </li>
        <li class="flex gap-3 items-center mb-3">
          <i class="pi pi-share-alt text-xl" style="color: #8dd0ff" />
          <span>{{ t('actions.5') }}</span>
        </li>
        <li class="flex gap-3 items-center">
          <i class="pi pi-cog text-xl" style="color: #8dd0ff" />
          <span>{{ t('actions.6') }}</span>
        </li>
      </ul>
    </div>

    <template #footer>
      <Button
        @click="emit('update:visible', false)"
        :label="t('close')"
        icon="pi pi-times"
        text
      />
    </template>
  </Dialog>
</template>

<i18n>
en:
  title: How to play
  descriptions:
    - >
      In the game, you have to take turns completing tasks of erotic content. Tasks will be given in turn: either to a
      guy or a girl. Everyone completes their task, ideally without showing it to their partner. If the task has a
      timer, then before completing it, you need to start the countdown. After completing a task, you move on to the
      next one.
    - If the tasks are too easy for you or you want to get even more thrills from the process - increase the level of
      the game.
  actions_title: 'Game control buttons:'
  actions:
    - Go to the next task
    - Start task timer
    - Level Up the Game
    - Replay the game
    - Add task to favorites
    - Copy task link
    - Go to game settings
  close: Close

ru:
  title: Как играть
  descriptions:
    - >
      В игре вам предстоит по очереди выполнять задания эротического содержания. Задания будут давать по очереди: то
      парню, то девушке. Каждый выполняет свое задание, в идеале, не показывая своему партнеру. Если задание имеет
      таймер, то перед его выполнением необходимо запустить отсчет времени. После выполнения задания вы переходите к
      следующему.
    - Если задания для вас слишком легкие или вы хотите получить еще большие ощущения от процесса - повысьте уровень
      игры.
  actions_title: 'Кнопки управления игрой:'
  actions:
    - Перейти к следующему заданию
    - Запустить таймер задания
    - Повысить уровень игры
    - Повторить игру сначала
    - Добавить задание в избранное
    - Скопировать ссылку на задание
    - Перейти к настройкам игры
  close: Закрыть

de:
  title: Wie man spielt
  descriptions:
    - 'Im Spiel müssen Sie abwechselnd Aufgaben mit erotischem Inhalt erledigen. Die Aufgaben werden abwechselnd
      vergeben: zuerst an den Mann, dann an das Mädchen. Jeder erledigt seine Aufgabe, am besten ohne es dem Partner zu
      zeigen. Wenn die Aufgabe über einen Timer verfügt, muss sie mit dem Countdown beginnen, bevor sie ausgeführt
      werden kann. Nachdem Sie eine Aufgabe erledigt haben, fahren Sie mit der nächsten fort.'
    - Wenn Ihnen die Aufgaben zu einfach sind oder Sie noch mehr Emotionen aus dem Prozess ziehen möchten, erhöhen Sie
      das Level des Spiels.
  actions_title: 'Spielsteuerungstasten:'
  actions:
    - Gehen Sie zur nächsten Aufgabe
    - Task-Timer starten
    - Verbessere dein Spiel
    - Wiederholen Sie das Spiel von Anfang an
    - Aufgabe zu Favoriten hinzufügen
    - Link zur Aufgabe kopieren
    - Gehen Sie zu den Spieleinstellungen
  close: Schließen

es:
  title: como jugar
  descriptions:
    - 'En el juego tienes que turnarte para completar tareas con contenido erótico. Las tareas se asignarán por turnos:
      primero al chico, luego a la chica. Cada uno hace su tarea, idealmente sin mostrársela a su pareja. Si la tarea
      tiene un temporizador, debe comenzar la cuenta regresiva antes de poder ejecutarse. Después de completar una
      tarea, pasas a la siguiente.'
    - Si las tareas te resultan demasiado fáciles o quieres obtener sensaciones aún mayores del proceso, aumenta el
      nivel del juego.
  actions_title: 'Botones de control del juego:'
  actions:
    - Ir a la siguiente tarea
    - Iniciar el cronómetro de tareas
    - Sube de nivel tu juego
    - Repite el juego desde el principio.
    - Agregar tarea a favoritos
    - Copiar enlace a la tarea
    - Ir a la configuración del juego
  close: Cerca

fr:
  title: Comment jouer
  descriptions:
    - "Dans le jeu, vous devez accomplir à tour de rôle des tâches à contenu érotique. Les tâches seront confiées à tour
      de rôle : d'abord au gars, puis à la fille. Chacun fait sa tâche, idéalement sans la montrer à son partenaire. Si
      la tâche dispose d'une minuterie, elle doit alors démarrer un compte à rebours avant de pouvoir être exécutée.
      Après avoir terminé une tâche, vous passez à la suivante."
    - Si les tâches sont trop faciles pour vous ou si vous souhaitez obtenir des sensations encore plus grandes du
      processus, augmentez le niveau du jeu.
  actions_title: 'Boutons de contrôle du jeu :'
  actions:
    - Passer à la tâche suivante
    - Démarrer le minuteur de tâches
    - Améliorez votre jeu
    - Répétez le jeu depuis le début
    - Ajouter une tâche aux favoris
    - Copier le lien vers la tâche
    - Accédez aux paramètres du jeu
  close: Fermer
</i18n>
